import {Component, OnInit} from '@angular/core';
import {AppService, CartService} from "../../../../common";
import {Router} from "@angular/router";


@Component({
  selector: 'demo-success',
  standalone: false,
  template: `
<main class="success container full-height d-flex flex-column justify-content-center">
  <p class="text-center text-success">
    <i class="fa fa-check-circle fa-4x"></i>
  </p>
  <h3 class="text-center" i18n>Order sent</h3>
  <p class="text-center" i18n>
    Note: This is only a demo, so there will be further processing.<br><br>
    In the real system, customers can information about the status
    of their order via e-mail. And, of course, tasty food and drinks.
  </p>
  <p class="text-center">
    <button (click)="onBtClose($event)" class="btn btn-primary" i18n>Make another test order</button>
  </p>
</main>
  `
})

export class DemoSuccessPage implements OnInit {

  constructor(
    private router: Router,
    private appService: AppService
  ) { }

  ngOnInit(): void {

  }

  onBtClose(event: MouseEvent) {
    event.preventDefault();
    if (this.appService.cart) {
      this.appService.cart.clear();
    }
    this.router.navigate(['/']);
  }
}
